query StreamEntrypointShowQuery($id: ID!) {
  streamEntrypoint(id: $id) {
    id
    title
    liveConnected
    lastPublishAt
    lastPublishFinishAt
    cfAccountId
    liveInputId
    createdAt
    updatedAt
    platform {
      id
      title
    }
    stream {
      id
      title
    }
    pull {
      sourceUrl
      status
      attempt
      maxAttempts
      startedAt
      finishedAt
      lastError {
        message
      }
    }
  }
}
